import { api } from "./api";
import { Post } from "./postAPI";

export interface Category {
  id: number;
  name: string;
  depth: number;
  children: Category[];
  posts: Post[];
  listOrder: number;
}

export const getBoardList = async () => {
  try {
    const { data } = await api().get("/boards");
    return data.data;
  }
  catch (e) {
    console.log(e);
  }
};

export const getBoardListWithRootCategory = async () => {
  try {
    const { data } = await api().get("/boards-with-root-category");
    return data.data;
  }
  catch (e) {
    console.log(e);
  }
};

// 기존 getCategory와 동일, 이름 변경 예정
export const newGetCategory = async ( categoryId: number ) => {
  try {
    const params = { parentCategoryId: categoryId };
    const { data } = await api().get("/category", { params });
    return data.data;
  }
  catch (e) {
    throw e;
  }
};

// getCategoryInfo 응답의 카테고리 노드. 자기 자신 + 하위 카테고리들이 children 으로 재귀적으로 내려옴
// (root → main(children) → sub(children[].children))이라, 한 번의 호출로 전체 트리를 얻을 수 있음
export interface CategoryTreeNode {
  id: number;
  name: string;
  categoryType: string;
  listOrder: number;
  postCnt: number;
  slideCnt: number;
  children: CategoryTreeNode[];
}

export const getCategoryInfo = async (
  categoryId: number,
): Promise<CategoryTreeNode> => {
  const { data } = await api().get(`/category/${categoryId}`);
  const node = data?.data;
  // 방어적으로 children 을 항상 배열로 보장 → 호출부에서 optional chaining 없이 사용 가능
  return { ...node, children: node?.children ?? [] };
};

export const getCategoryChildren = async (categoryId: number) => {
  try {
    const { data } = await api().get(`/category-children/${categoryId}`);
    return data.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

//제거 예정
export const postCategory = async (
  name: string,
  parentId: number,
  depth: number,
) => {
  try {
    const body = { name, parentId, depth };
    const { data } = await api().post("/category", body);
    return data;
  } catch (e) {
    console.log(e);
  }
};

//이름 변경 예정
export const newPostCategory = async ( name: string, parentId: number, type: string ) => {
  try {
    const body = { name, parentId, type };
    const { data } = await api().post("/category", body);
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const changeParentCategory = async ( categoryId: number, changeCategoryId: number, listOrder: number ) => {
  try {
    const body = { categoryId, changeCategoryId, listOrder };
    const { data } = await api().put("/category/change", body);
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const reorderCategory = async ( categoryList: { categoryId: number; listOrder: number }[] ) => {
  try {
    const { data } = await api().put("/category/listOrder/multiple", categoryList);
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const putCategory = async (id: number, name: string) => {
  try {
    const body = { id, name };
    const { data } = await api().put("/category", body);
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const putCategoryOrder = async (
  categoryId: number,
  listOrder: number,
) => {
  try {
    const body = { categoryId, listOrder };
    const { data } = await api().put("/category/listOrder", body);
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const deleteCategory = async (id: number) => {
  try {
    const { data } = await api().delete(`/category/${id}`);
    return data;
  } catch (e) {
    console.log(e);
  }
};
